import { DialogContent, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React, { Dispatch } from 'react';
import STRING_KEYS from '../../../../language/keys';
import { Search as SearchIcon } from '../../../../icons/search';
import { ContentStyle } from './style';
import SelectIconModalItem from './SelectIconModalItem';

type SelectIconModalContentProps = {
    onClick: (value: string) => void,
    onInputChange: Dispatch<React.SetStateAction<string>>,
    value: string,
    data: {name:string, url:string}[],
}

export default function SelectIconModalContent({
  onClick, onInputChange, value, data,
}:SelectIconModalContentProps): JSX.Element {
  const { t: translate } = useTranslation();
  const getIconsList = () => {
    return (
      data && data.map((item: {name:string, url:string}) => (
        <SelectIconModalItem
          key={ item.name }
          name={ item.name }
          url={ item.url }
          onClick={ onClick }
        />
      ))
    );
  };

  return (
    <DialogContent style={ ContentStyle.dialogContent }>
      <TextField
        fullWidth
        placeholder={ translate(STRING_KEYS.MULTI_SELECT.SEARCH_PLACEHOLDER) }
        onChange={ (e:React.ChangeEvent<HTMLInputElement>) => onInputChange(e.target.value) }
        value={ value }
        InputProps={ {
          startAdornment: <SearchIcon style={ ContentStyle.input } />,
        } }
      />
      <div style={ ContentStyle.container }>
        {getIconsList()}
      </div>
    </DialogContent>
  );
}
